import * as XLSX from 'xlsx'

export const getInternshipDataExcel = (data, batchYear) => {
    if(data.length > 0){

        let maxNumberOfInternships = 0;

        for(let i = 0; i < data.length; i++){
            if (data[i]?.internshipsArray?.length > maxNumberOfInternships) {
                maxNumberOfInternships = data[i]?.internshipsArray?.length;
            }
        }   

        let columnHeaders = ["SAP ID", "Name", "Email", "Contact","sem3" ,"sem4","sem5","sem6","sem7","sem8" ];



        for (let i = 0; i < maxNumberOfInternships; i++) {
            let temp = 'internship' + (i + 1).toString();
            columnHeaders.push(temp);
            
            temp = 'internship' + (i + 1).toString() + " role";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " description";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " proof_link";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " start_date";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " end_date";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " numberOfHours";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " nature";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " offer_letter_link";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " external_evaluation_link";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " internal_evaluation_link";
            columnHeaders.push(temp);

            temp = 'internship' + (i + 1).toString() + " stipend";
            columnHeaders.push(temp);
        }



        let rows = []
        rows.push(columnHeaders);


        for (let i = 0; i < data.length; i++) {
            let eachRow = [];
            eachRow.push(data[i].sap_Id);
            eachRow.push(data[i].name);
            eachRow.push(data[i].email);
            eachRow.push(data[i].contact_no);

            for(let k = 0; k < 6; k++){
                if(k < data[i].academic_cgpa.length){
                    eachRow.push(data[i].academic_cgpa[k]);
                }else{
                    eachRow.push("-");
                }
            }

    
            for (let j = 0; j < maxNumberOfInternships; j++) {
                if(j < data[i].internshipsArray.length){
                    
                    eachRow.push(data[i].internshipsArray[j].name)
                    eachRow.push(data[i].internshipsArray[j].role)
                    eachRow.push(data[i].internshipsArray[j].description)
                    eachRow.push(data[i].internshipsArray[j].proof_link)
                    eachRow.push(data[i].internshipsArray[j].start_date)
                    eachRow.push(data[i].internshipsArray[j].end_date)
                    eachRow.push(data[i].internshipsArray[j].numberOfHours)
                    eachRow.push(data[i].internshipsArray[j].nature)
                    eachRow.push(data[i].internshipsArray[j].offer_letter_link)
                    eachRow.push(data[i].internshipsArray[j].external_evaluation_link.length > 0 ? data[i].internshipsArray[j].external_evaluation_link : "-")
                    eachRow.push(data[i].internshipsArray[j].internal_evaluation_link.length > 0 ? data[i].internshipsArray[j].internal_evaluation_link : "-")
                    eachRow.push(data[i].internshipsArray[j].stipend);

                }else {
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                    eachRow.push("-");
                }
            }
            console.log(rows.push(eachRow));
        }

        var worksheet = XLSX.utils.aoa_to_sheet(rows);
        const wb = { Sheets: { data: worksheet }, SheetNames: ["data"] };
        XLSX.writeFile(wb, `${batchYear}_data.xlsx`)

    }

}